import React, { ButtonHTMLAttributes, FC } from 'react';
import styled from '@xstyled/styled-components';
import BurgerIcon from '~/assets/icons/burger2.svg';

const Button = styled.button`
  background: #fff;
  left: 0px;
  position: inherit;
`;

const Burger = styled(BurgerIcon)`
  width: 20px;
  height: 15px;
`;

export const DragButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  ...props
}) => (
  <Button {...props}>
    <Burger />
  </Button>
);
